import React, { useState } from 'react';
import { Button, Check } from '@fx-ui/fine-design';
import { forEach, hasFunctionTenantRegister, isEmpty, isMobileUA, map, pick } from '~/utils';
import Intl from '@fx-ui/intl';
import { InvitationInfo } from '~/interfaces';
import LogoPageLayout from '~/container/logo-page-layout';
import useJoinCorp from '../../hooks/useJoinCorp';
import classNames from 'classnames';

interface IMemberInviteAcceptPaneProps {
    invites: InvitationInfo[];
    onCancel: () => Promise<void> | void;
}

const MemberInviteAcceptPane: React.FunctionComponent<IMemberInviteAcceptPaneProps> = (props) => {
    const { invites, onCancel } = props;

    const [value, setValue] = useState<InvitationInfo[]>(
        map(invites, (item) => pick(item, ['corpId', 'memberId']))
    );

    const { renderAuthMfa, joinCorp } = useJoinCorp();

    const selectAll = () => {
        if (!isAllChecked()) {
            setValue(map(invites, (item) => pick(item, ['corpId', 'memberId'])));
        } else {
            setValue([]);
        }
    };

    const selectItem = (item: any) => {
        const arr = [...value];
        if (!isItemChecked(item)) {
            arr.push(pick(item, ['corpId', 'memberId']));
        } else {
            let idx = -1;
            forEach(value, (val, index) => {
                if (item.memberId === val.memberId && item.corpId === val.corpId) {
                    idx = index;
                    return false;
                }
            });
            if (idx > -1) {
                arr.splice(idx, 1);
            }
        }
        setValue(arr);
    };

    const isAllChecked = () => {
        let checked = true;
        forEach(invites, (item) => {
            if (!isItemChecked(item)) {
                checked = false;
                return false;
            }
        });
        return checked;
    };

    const isItemChecked = (item: any) => {
        let checked = false;
        forEach(value, (val) => {
            if (item.memberId === val.memberId && item.corpId === val.corpId) {
                checked = true;
                return false;
            }
        });
        return checked;
    };

    return (
        <LogoPageLayout>
            <div
                className={classNames('fx-member-invite-accept-pane', {
                    'is-mobile': isMobileUA()
                })}
            >
                <div className="invite-title">{Intl.get('message.team.invite')}</div>
                <div className="invite-sub-title">{Intl.get('member.invite.accept.guide')}</div>
                <div className="pane-invite-list">
                    <div className="invite-head">
                        <Check
                            className="invite-check"
                            checked={isAllChecked()}
                            onChange={selectAll}
                        />
                        <div className="invite-manager">{Intl.get('manager')}</div>
                        <div className="invite-corp">{Intl.get('corp.name.label')}</div>
                    </div>
                    <div className="invite-body">
                        {map(invites, (item, index) => (
                            <div key={index} className="invite-item">
                                <Check
                                    className="invite-check"
                                    checked={isItemChecked(item)}
                                    onChange={() => selectItem(item)}
                                />
                                <div className="invite-manager" title={item.inviterName}>
                                    {item.inviterName}
                                </div>
                                <div className="invite-corp" title={item.corpName}>
                                    {item.corpName}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <Button
                    className="btn-invite"
                    type="primary"
                    size="large"
                    disabled={isEmpty(value)}
                    loadingWhenClick
                    onClick={() => {
                        return new Promise<void>((resolve) => {
                            joinCorp(value).catch(() => {
                                resolve();
                            });
                        });
                    }}
                >
                    {Intl.get('invite.accept')}
                </Button>
                {hasFunctionTenantRegister() && (
                    <Button
                        className="btn-cancel"
                        type="text"
                        size="large"
                        loadingWhenClick
                        onClick={onCancel}
                    >
                        {Intl.get('talkLater')}
                    </Button>
                )}
                {renderAuthMfa()}
            </div>
        </LogoPageLayout>
    );
};

export default MemberInviteAcceptPane;
